<template>
	<div class="custom-survey-forms">
		<h2 class="content-block">
			<a :href="surveyConfig.linkHeaderImage" v-if="surveyConfig.linkHeaderImage && (showHeaderImage && !surveyConfig.disableHeaderImage)" target="_blank">
				<img src="@/assets/colpuno_big_transparent.png" class="header-image" v-if="!surveyConfig.replaceHeaderImage" />
				<img :src="surveyConfig.replaceHeaderImage" class="header-image" v-else />
			</a>
			<img v-else-if="showHeaderImage && !surveyConfig.disableHeaderImage && !surveyConfig.replaceHeaderImage" src="@/assets/colpuno_big_transparent.png" class="header-image" />
			<img v-else-if="showHeaderImage && !surveyConfig.disableHeaderImage && surveyConfig.replaceHeaderImage" :src="surveyConfig.replaceHeaderImage" class="header-image" />
			<div class="header-title">{{ surveyConfig.title ? surveyConfig.title : 'Survey' }}</div>
		</h2>

		<DxPopup v-model:visible="submitError" @hidden="submitError = false" title="Error submitting survey"
			:shading="true" shadingColor="#ccca" :showTitle="true" :showCloseButton="true" :dragEnabled="false" :hideOnOutsideClick="true"
			max-width="400px" max-height="280px">
			<div class="submitsurvey-error-body">{{ submitErrorMsg }}</div>
		</DxPopup>

		<DxPopup v-if="surveyConfig.intro && surveyConfig.intro.video" v-model:visible="videoPopup" :shading="true" shadingColor="#ccca" :showTitle="true" :showCloseButton="true" :dragEnabled="false" :hideOnOutsideClick="true" :wrapper-attr="{ class: 'video-popup' }"
			max-width="480px" max-height="520px" :fullScreen="smallScreenVideo"
			:onShown="videoPopupToggled" :onHiding="videoPopupToggled">
			<video controls :src="surveyConfig.intro.video" ref="videoPopupVideo" width="100%" height="100%"/>
		</DxPopup>
		
		<div class="content-block dx-card responsive-paddings application-form" v-if="existingForm.id">
			<div class="existing-warning" v-if="!surveyConfig.finished">
				<i class="dx-icon dx-icon-check" style="font-size: 48px;color:green;"></i><br>
				<b>Thank you for submitting your survey form.</b><br>
				If necessary, we will send you an email with any further details.
			</div>
			<div class="existing-warning" v-if="surveyConfig.finished">
				<template v-if="surveyConfig.finished.tick"><i class="dx-icon dx-icon-check" style="font-size: 48px;color:green;"></i><br></template>
				<template v-if="surveyConfig.finished.title"><b>{{ surveyConfig.finished.title }}</b><br></template>
				<div v-if="surveyConfig.finished.description">{{ surveyConfig.finished.description }}</div>
				<div v-if="surveyConfig.finished.raw" v-html="surveyConfig.finished.raw"></div>
				<div v-if="surveyConfig.finished.clickthru" style="margin-top:1em;">
					<a :href="surveyConfig.finished.clickthru.link ? surveyConfig.finished.clickthru.link : '#'">
						<img :src="surveyConfig.finished.clickthru.logo" style="width: 100px; height: 100px;" />
						<div>{{ surveyConfig.finished.clickthru.text }}</div>
					</a>
				</div>
				<div v-if="surveyConfig.finished.raffle && surveyConfig.finished.raffle.enabled && existingForm.raffle">
					<div v-if="surveyConfig.finished.raffle.messageRaw" v-html="processRaffleHtml(surveyConfig.finished.raffle.messageRaw, existingForm.raffle)"></div>
					<div v-else>Your raffle number is: {{ existingForm.raffle }}</div>
				</div>
				<div v-else-if="surveyConfig.finished.raffle && surveyConfig.finished.raffle.enabled && !existingForm.raffle">
					<div style="font-weight:bold;color:red;margin-top: 2em;">Sorry, there was an error loading your raffle number.</div>
				</div>
			</div>
		</div>

		<div class="content-block dx-card responsive-paddings application-form" v-if="surveyConfig.type && !existingForm.id">
			<form @submit.prevent="submitGeneralSurvey" enctype="multipart/form-data">
				<DxForm id="custom-survey-dxform" ref="formRef" label-mode="floating" :col-count="surveyConfig.cols" :form-data="applicationData" validation-group="surveyValidationGroup">
					<DxTabbedItem>
						<DxTabPanelOptions :swipe-enabled="false" :repaint-changes-only="true" :defer-rendering="false" :selected-index="tabSelectedIndex" @titleClick="formTabChanged" />
						<DxTab v-if="surveyConfig.intro" :title="surveyConfig.intro.label ? surveyConfig.intro.label : 'Introduction'">
							<DxSimpleItem>
								<DxBox :direction="smallScreenVideo ? 'col' : 'row'" width="100%" class="simple-item-descriptive dx-card dx-theme-accent-as-border-color" :style="surveyConfig.intro.containerStyles ? surveyConfig.intro.containerStyles : ''">
									<DxItem v-if="surveyConfig.intro.descriptionLogo" :ratio="0" :baseSize="smallScreenVideo ? 'auto' : 100">
										<div style="margin-top: 5px;">
											<img :src="surveyConfig.intro.descriptionLogo" style="width: 100px; height: auto; margin: 10px auto auto auto; display: block" />
										</div>
									</DxItem>
									<DxItem v-if="surveyConfig.intro.descriptionLogo" :ratio="0" :baseSize="smallScreenVideo ? 0 : 15">
										<div></div>
									</DxItem>
									<DxItem :ratio="smallScreenVideo ? 0 : 1" :baseSize="smallScreenVideo ? 'auto' : 0">
										<div>
											<p class="simple-item-descriptive-title">{{ surveyConfig.intro.title }}</p>
											<template v-if="surveyConfig.intro.description">
												<p v-for="line in surveyConfig.intro.description.split('\n')" :key="line">{{ line }}</p>
											</template>
											<div v-if="surveyConfig.intro.descriptionRaw" v-html="surveyConfig.intro.descriptionRaw"></div>
										</div>
									</DxItem>
									<DxItem v-if="surveyConfig.intro.video" :visible="!smallScreenVideo" :ratio="0" :baseSize="10"></DxItem>
									<DxItem v-if="surveyConfig.intro.video" :ratio="smallScreenVideo ? 0 : 0" :baseSize="smallScreenVideo ? 300 : 200">
										<div class="simple-item-videobox" @click="videoPopup = true" :style="{ backgroundImage: `url(${surveyConfig.intro.videoThumb})` }">
											<div><i style="font-size:48px;" class="dx-icon-video"></i></div>
											<span>Play Video</span>
										</div>
									</DxItem>
								</DxBox>
							</DxSimpleItem>
							<DxSimpleItem v-if="surveyConfig.intro.whoAreWe">
								<div class="simple-item-descriptive dx-card dx-theme-accent-as-border-color">
									<p class="simple-item-descriptive-title">Who are we?</p>
									<p :class="{ 'simple-item-descriptive-logoshow': true, 'tiny-logoshow': isTiny }" v-for="who in surveyConfig.intro.whoAreWe" :key="who.title">
										<img :src="who.logo" style="width: 100px; height: 100px;" />
										<span v-if="who.title && who.description"><b>{{ who.title }}</b> {{ who.description }}</span>
										<span v-else-if="who.raw" v-html="who.raw"></span>
									</p>
								</div>
							</DxSimpleItem>
							<DxSimpleItem v-if="surveyConfig.intro.showPrivacy">
								<div class="simple-item-descriptive dx-card dx-theme-accent-as-border-color" style="padding: 20px;">
									<DxBox direction="row">
										<DxItem :ratio="0" :baseSize="40">
											<DxCheckBox v-model:value="applicationData.agree_privacy_policy" />
										</DxItem>
										<DxItem :ratio="1">
											<div><div>I have read and agree with the <a :href="surveyConfig.conclusion.privacy_custom ? surveyConfig.conclusion.privacy_custom : '/privacy.html'" target="_blank">Privacy Policy</a> regarding usage of my data.</div></div>
										</DxItem>
									</DxBox>
								</div>
							</DxSimpleItem>
							<DxButtonItem horizontal-alignment="right" :css-class="surveyConfig.intro.nextBtnHighlight ? 'throbbing-button' : ''">
								<DxButtonOptions :text="surveyConfig.intro.nextBtnText ? surveyConfig.intro.nextBtnText : 'Next'" type="default" :onClick="() => doFormTabChanged(1)" />
							</DxButtonItem>
						</DxTab>
						<DxTab v-for="(tab, tabIndex) in surveyConfig.tabs" :key="tab.key" :title="tab.title" :visible="tab.visible ?? true">
							<DxGroupItem v-for="group in surveyFields.filter(f => f.tab == tab.key && f.type == 'group')" :key="group.key" :caption="group.label" :col-count="group.cols || 1" :visible="isFieldItemVisible(group)">
								<template v-for="item in group.items" :key="item.key">
									<DxSimpleItem v-if="!item.type || item.type == 'text'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined" />
									<DxSimpleItem v-if="item.type == 'textarea'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1"
										editor-type="dxTextArea" :editor-options="{ height: item.height || 100 }" :visible="isFieldItemVisible(item)" :help-text="item.help || (isTiny ? ('↸ ' + item.label) : undefined)" />
									<DxSimpleItem v-if="item.type == 'email'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1"
										editor-type="dxTextBox" :editor-options="{ mode: 'email' }" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined">
										<DxEmailRule v-if="item.required" message="Email is invalid" />
									</DxSimpleItem>
									<DxSimpleItem v-if="item.type == 'number'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1"
										editor-type="dxNumberBox" :editor-options="{ min: item.min || undefined, max: item.max || undefined }" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined" />
									<DxSimpleItem v-if="item.type == 'phone'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1"
										editor-type="dxTextBox" :editor-options="{ mode: 'tel', mask: item.mask || undefined, maskInvalidMessage: item.maskInvalid || 'Invalid phone number' }" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined">
									</DxSimpleItem>
									<DxSimpleItem v-if="item.type == 'date'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1" 
										editor-type="dxDateBox" :editor-options="{ type: 'date', pickerType: 'native', min: item.min || undefined,max: item.max || undefined, dateSerializationFormat: item.format || 'yyyy-MM-dd' }" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined" />
									<DxSimpleItem v-if="item.type == 'select'" :data-field="item.key" :is-required="item.required" :label="{ text: item.label }" :col-span="item.colSpan || 1"
										:editor-type="item.multiple ? 'dxTagBox' : 'dxSelectBox'" :editor-options="computeSelectOptions(item)" :visible="isFieldItemVisible(item)" :help-text="item.help || undefined" />
									<DxSimpleItem v-if="item.type == 'rated'" :col-span="item.colSpan || 1">
										<RatedTopics :label="item.label" validationGroup="surveyValidationGroup" :topics="computeRatedOptions(item, 'topics')" :ratings="computeRatedOptions(item, 'ratings')" :initial="applicationData[item.key]" @valueChanged="applicationData[item.key] = $event;" />
									</DxSimpleItem>
									<DxEmptyItem v-if="item.type == 'empty'" :col-span="item.colSpan || 1" :visible="isFieldItemVisible(item)" />
									<DxSimpleItem v-if="item.type == 'info'" :col-span="item.colSpan || 1" :visible="isFieldItemVisible(item)" css-class="info-item"><div v-if="item.raw" v-html="item.raw"></div>{{ item.label }}</DxSimpleItem>
								</template>
							</DxGroupItem>
							<DxButtonItem horizontal-alignment="right" :visible="showFinalizeButton" v-if="surveyConfig.conclusion">
								<DxButtonOptions icon="chevrondoubleright" text="Back to Conclusion" type="success" :onClick="() => doFormTabChanged(surveyConfig.tabs.length + (surveyConfig.intro ? 1 : 0) + (surveyConfig.conclusion ? 1 : 0) - 1)" />
							</DxButtonItem>
							<DxButtonItem horizontal-alignment="right" :visible="!showFinalizeButton">
								<DxButtonOptions text="Next" type="default" :onClick="() => doFormTabChanged(tabIndex + (surveyConfig.intro ? 2 : 1))" />
							</DxButtonItem>
						</DxTab>
						<DxTab v-if="surveyConfig.conclusion" :title="surveyConfig.conclusion.label ? surveyConfig.conclusion.label : 'Conclusion'">
							<DxSimpleItem>
								<div class="simple-item-descriptive dx-card dx-theme-accent-as-border-color">
									<div>
										<p class="simple-item-descriptive-title" v-if="surveyConfig.conclusion.title">{{ surveyConfig.conclusion.title }}</p>
										<p class="simple-item-descriptive-title" style="font-size:14px;font-style:italic;" v-if="surveyConfig.conclusion.subtitle">{{ surveyConfig.conclusion.subtitle }}</p>
										<p v-for="line in surveyConfig.conclusion.description.split('\n')" :key="line">{{ line }}</p>
										<p class="simple-item-descriptive-title" v-if="surveyConfig.conclusion.ctaTitle">{{ surveyConfig.conclusion.ctaTitle }}</p>
										<DxBox direction="row" v-if="surveyConfig.conclusion.ctaTitle">
											<DxItem :ratio="0" :baseSize="40">
												<DxCheckBox v-model:value="applicationData.agree_cta" />
											</DxItem>
											<DxItem :ratio="1">
												{{ surveyConfig.conclusion.ctaDescription }}
											</DxItem>
										</DxBox>
										<p style="font-style: italic; padding-left: 40px; margin-top: 5px;" v-if="surveyConfig.conclusion.ctaAdditional">{{  surveyConfig.conclusion.ctaAdditional }}</p>
										<DxBox direction="row" :visible="surveyConfig.conclusion.ctaGatherEmail && applicationData.agree_cta" style="margin:1em 0;">
											<DxItem :ratio="0" :baseSize="40">
											</DxItem>
											<DxItem :ratio="1">
												<div><div>My email address is:</div><div><DxTextBox v-model:value="applicationData.cta_email" :required="surveyConfig.conclusion.ctaGatherEmail" /></div></div>
											</DxItem>
										</DxBox>
										<DxBox direction="row">
											<DxItem :ratio="0" :baseSize="40">
												<DxCheckBox v-model:value="applicationData.agree_privacy_policy" />
											</DxItem>
											<DxItem :ratio="1">
												<div><div>I have read and agree with the <a :href="surveyConfig.conclusion.privacy_custom ? surveyConfig.conclusion.privacy_custom : '/privacy.html'" target="_blank">Privacy Policy</a> regarding usage of my data.</div></div>
											</DxItem>
										</DxBox>
										<p style="font-style: italic; padding-left: 40px; margin-top: 5px;" v-if="surveyConfig.conclusion.privacy_extras">{{  surveyConfig.conclusion.privacy_extras }}</p>
										<p v-if="surveyConfig.conclusion.ending">{{ surveyConfig.conclusion.ending }}</p>
										<div v-else style="height:15px;"></div>
									</div>
								</div>
							</DxSimpleItem>
							<DxSimpleItem data-field="inviter" :visible="surveyConfig.conclusion.showInviter === true && !surveyConfig.conclusion.useInviterArray" :is-required="false" editor-type="dxTextArea" :editor-options="{ placeholder: 'person@email.com, person@email.com, ...' }" :label="{ text: surveyConfig.conclusion.inviterLabel || 'Do you have any colleagues you can invite to this survey, or to join our community?' }">
							</DxSimpleItem>
							<template v-if="surveyConfig.conclusion.showInviter === true && surveyConfig.conclusion.useInviterArray === true">
								<DxSimpleItem>
									<RatedTopics :label="surveyConfig.conclusion.inviterLabel || 'Do you have any colleagues you can invite to this survey, or to join our community?'" :initial="[]" :topics="[]" :checkbox-mode="true" :plaintext-mode="true" :email-unique-mode="true" @valueChanged="applicationData['inviter'] = $event;" />
								</DxSimpleItem>
							</template>
							<DxButtonItem :button-options="{ type: 'success', text: 'Submit Form', useSubmitBehavior: false, onClick: submitForm }" />
						</DxTab>
					</DxTabbedItem>

				</DxForm>
			</form>
			<DxLoadPanel :position="{ of: '.application-form' }" :shading="true" shadingColor="rgba(0,0,0,0.4)" v-model:visible="loadingVisible" />
		</div>
	</div>
</template>

<script setup>
/* eslint-disable */
import { DxForm, DxSimpleItem , DxGroupItem, DxButtonItem, DxButtonOptions, DxEmptyItem, DxRequiredRule, DxEmailRule, DxTabbedItem, DxTab, DxTabPanelOptions, DxLabel } from "devextreme-vue/form";
import DxTextArea from 'devextreme-vue/text-area';			// eslint-disable-line no-unused-vars
import DxSelectBox from 'devextreme-vue/select-box';		// eslint-disable-line no-unused-vars
import { DxDateBox } from 'devextreme-vue/date-box';		// eslint-disable-line no-unused-vars
import DxTagBox from 'devextreme-vue/tag-box';				// eslint-disable-line no-unused-vars
import DxCheckBox from 'devextreme-vue/check-box';			// eslint-disable-line no-unused-vars
import DxTextBox from 'devextreme-vue/text-box';			// eslint-disable-line no-unused-vars
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxBox, DxItem } from 'devextreme-vue/box';
import DxPopup from "devextreme-vue/popup"
import DxButton from 'devextreme-vue/button';
import { inject, ref, computed, onMounted, onUnmounted, nextTick } from "vue";
import { useRouter, useRoute } from 'vue-router';
import RatedTopics from '../components/rated-topics.vue';
import to from 'await-to-js';
import notify from 'devextreme/ui/notify';
import { sizes as mediaSizes, subscribe as subscribeMediaQuery, unsubscribe as unsubscribeMediaQuery } from '../utils/media-query';
import appInfo from '../app-info.js';

const $http = inject('$http');
const $route = useRoute();
const router = useRouter();
const SURVEY_TYPE = $route.params.surveyType;
const SURVEY_STOREKEY = appInfo.localPrefix + 'Survey_' + SURVEY_TYPE;
const applicationData = ref({
	agree_privacy_policy: false,
	agree_cta: true,
	survey_from: null,
});

// Note: We only support groups in the top level form, and everything MUST be in a group.
// This is because devextreme does not support using simpleitems/groupitems in sub-components of Vue. (See: https://supportcenter.devexpress.com/ticket/details/t1045156/form-dxsimpleitem-into-custom-component)
// This makes it impossible to use a custom component and allow recursive items/inputs, etc.
const surveyConfig = ref({});			// Survey configuration for our basic form and options.
const surveyFields = ref([]);			// Survey fields for rendering purposes.

// Survey configurations are stored in the data/surveys/<SURVEY_TYPE>.js files. See the sample.js file for an example.
if (!/^[a-zA-Z0-9_]+$/.test(SURVEY_TYPE)) {
    console.error('Invalid survey type - must contain only letters, numbers and underscores');
    surveyConfig.value = {};
} else {
    try {
        const surveyModule = require(`../data/surveys/${SURVEY_TYPE}.js`).default;
		surveyConfig.value = surveyModule.surveyConfig;
        surveyFields.value = surveyModule.surveyFields;
		if (surveyConfig.value.forceInitialize) {
			for (let initKey in surveyConfig.value.forceInitialize) {
				if (!(initKey in applicationData.value)) {
					applicationData.value[initKey] = surveyConfig.value.forceInitialize[initKey];
				}
			}
		}
    } catch (e) {
        console.error('Error loading survey configuration:', e);
        surveyConfig.value = {};
    }
}

// Compute the editor options for a select box given the field item.
function computeSelectOptions(item) {
	if (!item.options || !Array.isArray(item.options))
		return {};
	// For consistency, we always transform the options into an array of objects with id and label properties, even if options have no ids.
	// We also group the options with the label for a better mobile experience.
	// We support three-part key|group|value options for manually specified groups as well for non-multiple fields.
	let computedOptions = [];
	let manualGroupOptions = {};
	for (let option of item.options) {
		if (option.includes('|')) {
			let optionParts = option.split('|');
			if (optionParts.length == 3) {
				// Three part options mean we are using a manually specified group. These are added at the end.
				if (!manualGroupOptions[optionParts[1]]) {
					manualGroupOptions[optionParts[1]] = [];
				}
				manualGroupOptions[optionParts[1]].push({ id: optionParts[0], label: optionParts[2] });
			} else {
				computedOptions.push({ id: optionParts[0], label: optionParts[1] });
			}
		} else {
			computedOptions.push({ id: option, label: option });
		}
	}
	computedOptions = [{ key: item.label, items: computedOptions }];
	if (Object.keys(manualGroupOptions).length > 0) {
		// Special case: if we have no traditional key|value options, we can skip the first automated group we have made.
		if (computedOptions[0].items.length == 0) {
			computedOptions.shift();
		}
		for (let group of Object.keys(manualGroupOptions)) {
			computedOptions.push({ key: group, items: manualGroupOptions[group] });
		}
	}
	
	// Custom options require a special group at the bottom as well.
	if (item.custom) {
		computedOptions.push({ key: 'Other', items: [
			{ id: 'other_custom', label: "Type in any text..." }
		]});
	}

	return {
		dataSource: computedOptions,
		acceptCustomValue: item.custom ?? false,
		placeholder: item.placeholder ? item.placeholder : (item.custom ? "Select or type in an item..." : undefined),
		valueExpr: 'id',
		displayExpr: 'label',
		grouped: true,
		searchEnabled: item.search ?? false,
		onValueChanged: (event) => {
			// Automated value changed event for tagbox - we need to limit the number of values if there is a max value.
			// This is not supported by devextreme, so we need to do it manually.
			if (item.multiple && item.max) {
				if (event.value.length > item.max) {  
					applicationData.value[item.key] = event.previousValue;
				} 
			}
		},
		onCustomItemCreating: (args) => {		// This is safe because our data options are always their own objects and not shared references.
			if (!args.text) {
				args.customItem = null;
				return;
			}
			const { component, text } = args;
			const currentItems = component.option('items');
			const otherGroup = currentItems.find(cu => cu.key == 'Other');
			if (!otherGroup || !otherGroup.items[0]) {
				args.customItem = null;
				return;
			}
			otherGroup.items[0].id = text.trim();
			otherGroup.items[0].label = text.trim();
			args.customItem = otherGroup.items[0];
		}
	};
}

// Compute rated topics or ratings for a given field item using the rated type. Type should be either 'topics' or 'ratings'.
function computeRatedOptions(item, type) {
	if (type == 'topics') {
		let computedOptions = [];
		for (let option of item.options) {
			if (option.includes('|')) {
				let optionParts = option.split('|');
				computedOptions.push({ code: optionParts[0], name: optionParts[1] });
			} else {
				computedOptions.push({ code: option, name: option });
			}
		}
		return computedOptions;
	} else if (type == 'ratings') {
		if (!item.ratings || items.ratings.length == 0)
			return [];
		let computedRatings = [];
		for (let option of item.ratings) {
			if (option.includes('|')) {
				let optionParts = option.split('|');
				computedRatings.push({ id: optionParts[0], name: optionParts[1] });
			} else {
				computedRatings.push({ id: option, name: option });
			}
		}
		return computedRatings;
	}
	return [];
}


// Determine if a field item is visible if it has a visiblity condition in our configuration.
function isFieldItemVisible(item) {
	if (!item || !item.visible || (typeof item.visible != 'string' && !Array.isArray(item.visible)))
		return true;
	if (typeof item.visible == 'string') {
		item.visible = [ item.visible ];
	}
	for (let condition of item.visible) {
		// All conditions are ORs.
		let invert = condition.includes('!=');
		let conditionParts = condition.split(invert ? '!=' : '=');
		if (conditionParts.length !== 2)
			continue;
		let isVisible = false;
		if (applicationData.value[conditionParts[0]] && Array.isArray(applicationData.value[conditionParts[0]])) {
			isVisible = applicationData.value[conditionParts[0]].includes(conditionParts[1]);
		} else {
			isVisible = applicationData.value[conditionParts[0]] === conditionParts[1];
		}
		if (invert)
			isVisible = !isVisible;
		if (isVisible)
			return true;
	}
	return false;
}

const isTiny = ref(mediaSizes()['screen-x-small']);
const smallScreenVideo = ref(mediaSizes()['screen-x-small'] || mediaSizes()['screen-small']);
const mediaQueryHandler = () => {
	isTiny.value = mediaSizes()['screen-x-small'];
	smallScreenVideo.value =  mediaSizes()['screen-x-small'] || mediaSizes()['screen-small'];
};
onMounted(() => {
	subscribeMediaQuery(mediaQueryHandler);
	mediaQueryHandler();
	// Automatically set source of survey if encoded in url parameters 's' (from QR codes, redirects, etc.)
	if ($route.query && $route.query.s) {
		// We allow any string up to 255 characters to be used. We don't check it is a valid source if the key is being used by a field in our survey.
		applicationData.value.survey_from = String($route.query.s).substring(0, 255);
	}
});
onUnmounted(() => {
	unsubscribeMediaQuery(mediaQueryHandler);
});

const videoPopupToggled = () => {
	if (videoPopup.value) {		// Video was just opened
		videoPopupVideo.value.play();
	} else {					// Video was just closed
		videoPopupVideo.value.pause();
	}
};

const loadingVisible = ref(false);
const submitError = ref(false);
const submitErrorMsg = ref('');
const tabSelectedIndex = ref(0);
const formRef = ref(null);
const showHeaderImage = ref(true);
const videoPopup = ref(false);
const videoPopupVideo = ref(null);
const showFinalizeButton = ref(false);

const formTabChanged = (event) => {
	doFormTabChanged(event.itemIndex);
};
const doFormTabChanged = (tabIndex) => {
	tabSelectedIndex.value = tabIndex;
	showHeaderImage.value = tabIndex == 0;
	// If we are switching to a tab with skippable set, check to see if we should skip it (if all groups in it are not visible).
	let effectiveIndex = tabIndex - (surveyConfig.value.intro ? 1 : 0);
	let tab = surveyConfig.value.tabs[effectiveIndex];
	if (tab && tab.skippable) {
		// Early exit if any groups in the tab are visible.
		for (let field of surveyFields.value) {
			if (field.tab == tab.key && isFieldItemVisible(field)) {
				return;
			}
		}
		nextTick(() => {
			doFormTabChanged(tabIndex + 1);
		});
	}
}

const existingForm = ref({ id: null, edit_secret: null, raffle: null });
const existingFormStore = window.localStorage.getItem(SURVEY_STOREKEY);
if (existingFormStore) {
	// Load existing ID and secret from local storage if possible.
	let existingFormParts = existingFormStore.split(' ');
	existingForm.value.id = existingFormParts[0];
	existingForm.value.edit_secret = existingFormParts[1];
	existingForm.value.raffle = existingFormParts && existingFormParts.length > 2 ? existingFormParts[2] : null;
}

const submitForm = async () => {
	// Manually switch to the tab with the first invalid field, since we don't highlight them in any other way.
	let validationResult = formRef.value.instance.validate();
	if (!validationResult.isValid) {
		showFinalizeButton.value = true;
		let switchToTab = null;
		validationResult.brokenRules.forEach(rule => {
			let ruleElement = rule.validator.element();
			let tabElement = ruleElement?.closest('.dx-item[role=tabpanel]') ?? null;
			let tabIndex = tabElement ? [...tabElement.parentElement.children].indexOf(tabElement) : null;
			if (tabIndex !== null && switchToTab == null) {
				switchToTab = tabIndex;
			}
		});
		if (switchToTab != null	) {
			// We must switch to the tab first, then validate, otherwise the validation elements are not visible!	
			doFormTabChanged(switchToTab);
			nextTick(() => {
				formRef.value.instance.validate();
			});
		}
		return;
	}
	
	if (!applicationData.value.agree_privacy_policy) {
		notify({ message: "Sorry, you must agree to the privacy policy before submitting this form!", position: 'center', shading: true, shadingColor: '#cccc' }, "error", 3000);
		return;
	}

	if (surveyConfig.value.conclusion && surveyConfig.value.conclusion.ctaGatherEmail && applicationData.value.agree_cta) {
		if (!applicationData.value.cta_email) {
			notify({ message: "Please provide an email address to receive follow-up information!", position: 'center', shading: true, shadingColor: '#cccc' }, "error", 3000);
			return;
		} else if (!/^\S+@\S+$/.test(applicationData.value.cta_email)) {
			notify({ message: "Please provide a valid email address to receive follow-up information!", position: 'center', shading: true, shadingColor: '#cccc' }, "error", 3000);
			return;
		}
	}
	
	// Preprocess form data to remove any labels since we won't need to store them.
	// We clone the app data in preperation for preprocessing since in the event of an error, we want our original UI/forms to still work.
	let applicationDataClone = JSON.parse(JSON.stringify(applicationData.value));
	for (var i in applicationDataClone) {
		if (!Array.isArray(applicationDataClone[i]))
			continue;
		for (var j in applicationDataClone[i]) {
			delete applicationDataClone[i][j].label;
		}
	}
	
	// If we are using the RatedTopics component for the inviter, we need to convert the array to a string to match the inviter format.
	if (surveyConfig.value.conclusion && surveyConfig.value.conclusion.showInviter && surveyConfig.value.conclusion.useInviterArray) {
		if (applicationDataClone.inviter && Array.isArray(applicationDataClone.inviter)) {
			applicationDataClone.inviter = applicationDataClone.inviter.map(i => i.code).join(', ');
		}
	}
	
	console.log("Posting data", applicationDataClone);
	loadingVisible.value = true;
	let returnVal, err;
	let postUrl = '/survey';
	let formSubmission = {
		'_method': 'POST',
		'type': SURVEY_TYPE,
		'results': JSON.stringify(applicationDataClone),
		'raffle': surveyConfig.value.finished && surveyConfig.value.finished.raffle && surveyConfig.value.finished.raffle.enabled ? 1 : 0,
	};
	[ err, returnVal ] = await to($http.post(postUrl, formSubmission));
	loadingVisible.value = false;
	if (err) {
		console.error([ err ]);
		let errorMsg = err.message ? err.message : 'Unknown error';
		if (err.response && err.response.statusText) {
			errorMsg += "\n" + err.response.statusText;
		}
		submitError.value = true;
		submitErrorMsg.value = "Error submitting your form:\n" + errorMsg;
		return;
	}
	console.log(returnVal);

	// When complete, we store the existing form ID and secret in local storage as an easy way to mark that the form has been completed (since this is unauthenticated).
	// Secrets are split by space since these are never generated.
	if (returnVal.data.raffle) {
		window.localStorage.setItem(SURVEY_STOREKEY, returnVal.data.id + ' ' + returnVal.data.edit_secret + ' ' + returnVal.data.raffle);
	} else {
		window.localStorage.setItem(SURVEY_STOREKEY, returnVal.data.id + ' ' + returnVal.data.edit_secret);
	}
	notify({ message: "Your survey has been submitted successfully! Thank you for your time.", position: 'center', shading: true, shadingColor: '#cccc' }, "success", 3000);
	setTimeout(() => {
		router.go(0);
		window.location.reload();
	}, 3000);
}

// Simple function to process raffle HTML and replace %s / %d(1-5) with raffle number.
function processRaffleHtml(html, raffleNumber) {
	let raffleNumberStr = raffleNumber.toString();
	let raffleNumberArray = raffleNumberStr.split('');
	return html.replace(/%s/g, raffleNumberStr).replace(/%d(\d)/g, (match, p1) => raffleNumberArray[p1 - 1]);
}

</script>

<style lang="scss">
@import '../themes/generated/variables.base.scss';
.video-popup .dx-popup-content {
	overflow: hidden;
}
.custom-survey-forms {
	max-width: 1200px;
	.dx-tabpanel-container .dx-item-content.dx-multiview-item-content {
		.screen-x-small & {
			padding: 10px 5px;
		}
	}
	.content-block.dx-card.responsive-paddings.application-form {
		.screen-x-small & {
			padding: 10px;
		}
	}

	.header-image {
		width: 100%;
		max-width: 1200px;
	}
	.header-title {
		text-align: center;
		text-transform: uppercase;
		width: 100%; max-width: 1200px;
		border-bottom: 4px double black;
	}
	.header-subtitle {
		text-align: center;
		width: 100%; max-width: 1200px;
		font-size: 20px;
	}
	.application-form {
		max-width: 90vw;
	}
	.simple-item-descriptive {
		padding: 0 20px;
		border-left: 6px solid;
		text-align: justify;
		.screen-x-small & {
			padding: 0 10px;
			text-align: center;
		}
	}
	.simple-item-descriptive p+p {
		margin-top: 0;
	}
	.simple-item-descriptive-title {
		font-weight: bold;
		font-size: 1.2em;
	}
	.simple-item-videobox {
		display: flex;
		justify-content: center;
		color: #efefef;
		margin: 10px;
		font-size: 24px;
		text-align: center;
		background: #ccc;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		border: 2px solid #999;
		text-shadow: 2px 2px 3px #040404;
		cursor: pointer;
		min-height: 150px;
	}
	.simple-item-descriptive-logoshow {
		display: flex;
		align-items: center;
		column-gap: 15px;
		&.tiny-logoshow {
			flex-direction: column;
			row-gap: 10px;
		}
	}
	.submitsurvey-error-body {
		white-space: pre-line;
		border-left: 2px solid red;
		padding-left: 15px;
	}
	.existing-warning {
		text-align: center;
	}
	.group-hint-header {
		font-style: italic;
		padding: 0 !important;
		span {
			vertical-align: middle;
		}
		i {
			vertical-align: middle;
			padding-right: 5px;
		}
	}
	.language-row {
		padding: 10px 20px;
		border: 1px solid $base-border-color;
		border-left: 15px solid $base-border-color;
		margin-bottom: 1em;
		.language-level {
			background: $base-border-color;
			border: 1px solid $base-border-color;
			border-radius: 5px;
			padding: 2px 5px;
			margin-left: 10px;
		}
		.language-remove {
			cursor: pointer;
			float: right;
			margin-top: -4px;
			color: #f44336;
		}
	}
	.info-item {
		padding-top: 0 !important;
		padding-left: 5px !important;
		padding-right: 5px !important;
		font-style: italic;
	}
	
	.throbbing-button {
		.dx-button {
			animation: throbbing-border 2s ease-in-out infinite;
			border-radius: 4px;
		}
	}
	
	@keyframes throbbing-border {
		0% {
			box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
		}
		50% {
			box-shadow: 0 0 0 10px rgba(0, 123, 255, 0.3);
		}
		100% {
			box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
		}
	}
}
</style>
